const { ensure_initialized } = await import('@/plugins/firebase.js')
await ensure_initialized()
import('@/main.js')
export {}
